import { assertNever } from "@redotech/util/type";
import { createContext, memo, useMemo, useState } from "react";
import { MarketingModal, MarketingModalProps } from "./marketing-modal";

export const marketingModalTypes = ["commentsold"] as const;

export type MarketingModalType = (typeof marketingModalTypes)[number];

interface MarketingModalContext {
  openModal: (type: MarketingModalType) => void;
}

export const MarketingModalContext = createContext<MarketingModalContext>({
  openModal: () => {},
});

export const MarketingModalContextProvider = memo(
  function MarketingModalContextProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const [currentModal, setCurrentModal] = useState<MarketingModalType | null>(
      null,
    );

    const props: MarketingModalProps | null = useMemo(() => {
      if (!currentModal) {
        return null;
      }
      switch (currentModal) {
        case "commentsold":
          return {
            image: "https://assets.getredo.com/redo-suite/cs-redo.jpg",
            title:
              "Grabbing your audience’s attention is only half the battle.",
            subtitle:
              "With a fully branded mobile app, cutting-edge live selling technology, and smart automations, we help turn followers into loyal buyers. Our powerful e-commerce tools deliver 10x higher conversion rates, make every purchase quick and easy, and drive sustainable growth—without adding more to your to-do list.",
            onDismiss: () => setCurrentModal(null),
            isOpen: true,
            action: {
              type: "external",
              href: "https://try.commentsold.com/redo/",
              text: "Go to CommentSold",
            },
          };
        default:
          assertNever(currentModal);
      }
    }, [currentModal]);

    return (
      <MarketingModalContext.Provider value={{ openModal: setCurrentModal }}>
        {props && <MarketingModal {...props} />}
        {children}
      </MarketingModalContext.Provider>
    );
  },
);
